define('views/components/customer_settings/company_settings',['require','views/base/item_page_view','typeahead','bloodhound','text!templates/components/customer_settings/company_settings.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');

    var temp = require("text!templates/components/customer_settings/company_settings.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),

        afterInitialize: function () {

        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',

                chainField: '.chains-typeahead',
                cityField: '.cities-typeahead',

                countrySelect: '#country',
                stateSelect: '#state',
                phoneCountrySelect: '#phone_country'
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',

            'change @ui.countrySelect': 'countryChanged'
        },

        afterRender: function () {
            var _this = this;

            // Setup typeahed for chain field
            var chainsTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'customer-chains/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + _this.ui.chainField.val());
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.chainField.typeahead({
                minLength: 3
            }, {
                name: 'chains',
                source: chainsTypeahedEngine,
                display: 'name'
            });

            // Setup typeahed for city field
            var citiesTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'cities/typeahead/',
                    replace: function(url, query) {
                        var modifiedUrl = url + ('?query=' + _this.ui.cityField.val());

                        if (_this.model.get('country')) {
                            modifiedUrl += ('&country=' + _this.model.get('country'));
                        }

                        return modifiedUrl;
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cityField.typeahead({
                minLength: 3
            }, {
                name: 'cities',
                source: citiesTypeahedEngine,
                display: 'name'
            });
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'sector': "required",
                    'country': "required",
                    'city_name': "required",
                    'phone_country': "required",
                    'phone_value': "required",
                    'address': "required"
                },
                messages: {
                    'sector': App.polyglot.t('sector_required'),
                    'country': App.polyglot.t('country_required'),
                    'city_name': App.polyglot.t('city_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required'),
                    'address': App.polyglot.t('address_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        countryChanged: function () {
            var country_id = this.ui.countrySelect.val();

            if (country_id) {
                // Select same country in phone number field
                this.ui.phoneCountrySelect.val(country_id);
                this.ui.phoneCountrySelect.trigger('change');
                this.ui.stateSelect.val(null);
                this.ui.stateSelect.trigger('change');
                this.render();
            }
        }
    });
});
